import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { NotifyService } from 'common/util/services/notify.service'
import { APIService } from 'api/module'
import { GetAllMediaTagsRequest, MediaRoot, UnfilteredTag } from 'elements-sdk'

const LOAD_LIMIT = 100

@Component({
  selector: 'media-file-list-tags-dropdown',
  templateUrl: './mediaFileListTagsDropdown.component.pug',
  styleUrls: ['./mediaFileListTagsDropdown.component.scss'],
})
export class MediaFileListTagsDropdownComponent {
  @Input() root: MediaRoot
  @Output() addTag = new EventEmitter<UnfilteredTag>()
  @Output() removeTag = new EventEmitter<UnfilteredTag>()
  @Output() tagCreated = new EventEmitter<UnfilteredTag>()

  tags: UnfilteredTag[] = []
  filter = ''
  loading = false
  moreAvailable = false

  constructor (
    private translate: TranslateService,
    private api: APIService,
    private notify: NotifyService,
    private cdr: ChangeDetectorRef,
  ) { }

  onFilterChange () {
    this.loadTags(this.filter)
  }

  async loadTags (query: string|null, offset = 0) {
    const q: GetAllMediaTagsRequest = {
      forRoot: this.root.id,
      offset: offset || 0,
      limit: LOAD_LIMIT,
      ordering: 'name',
    }
    if (query) {
      q.nameIcontains = query
    }
    this.loading = true
    const tagsResponse = await this.api.mediaLibrary.getAllMediaTagsRaw(q)
    const tags = await tagsResponse.value()
    const pagination = this.api.extractPagination(tagsResponse)
    this.tags = offset ? this.tags.concat(tags) : tags
    this.moreAvailable = pagination ? this.tags.length < pagination.total : false
    this.loading = false
    this.cdr.markForCheck()
  }

  loadMore () {
    this.loadTags(this.filter, this.tags.length)
  }

  async createTag (name) {
    if (!name) {
      return
    }
    if (this.tags.some((x) => x.name === name)) {
      return
    }

    this.loading = true
    const tags = await this.api.mediaLibrary.getAllMediaTags({ roots: this.root.id.toString(), name })
    if (tags.length === 0) {
      const tag = await this.api.mediaLibrary.createMediaTag({
        unfilteredTagUpdate: {
          name,
          roots: [this.root.id],
        },
      })
      this.tags.push(tag)
      this.tagCreated.emit(tag)
    }

    this.filter = name
    this.loadTags(name)
    this.loading = false
  }
}
